
export default {
  ABI: {
    'Mandatary and statutorily required items': [
      'Employee Manual Acknowledgement',
      'HIPAA Training',
      'I-9',
      'Mutual Dispute Resolution Agreement',
      'NDA',
      'PTO Policy Acknowledgement',
      'Restrictive Covenant Agreement',
      'Sexual Harassment Policy Acknowledgement',
      'Wage Notice',
    ],
    'Performance review and post-employment information': [
      'Disciplinary Action Report',
      'Exit Records',
      'Performance Review',
    ],
    'Employee benefits administration': [
      'Commuter Benefits',
      'Medical Coverage Benefits',
      'Office staff benefit option form',
      'Employer funded form for benefit card option enrollee',
    ],
    Others: [
      'Code of Conduct Acknowledgement',
      'Direct Deposit',
      'Employee Application Form',
      'Employee Reference Check',
      'IT-2104',
      'Misc',
      'Offer Letter',
      'Recommendation Letters',
      'W-4',
      'Work Opportunity Tax Credit',
    ],
  },
};
